export const HISTORIES_TYPES = {
  BASEBALL_STAT_CLUB: 'baseballStatClub',
  BASEBALL_STAT_PLAYER: 'baseballStatPlayer',
};
